<template>
  <section>
    <v-card v-if="mock">
      <v-card-text>
        <v-text-field label="Name" v-model="mock.name" outlined dense required/>

        <v-select label="Parent"
                  :items="available_parents"
                  v-model="mock.parent_id"
                  item-text="name"
                  item-value="id"
                  :error-messages="api_errors['parent_id']"
                  clearable
                  outlined
                  dense
        >
          <template v-slot:item="{ item }">
            {{ item.name }} / {{ item.practice_area.name }} / {{ item.session_type.name }}
          </template>
          <template v-slot:selection="{ item }">
            {{ item.name }} / {{ item.practice_area.name }} / {{ item.session_type.name }}
          </template>
        </v-select>

        <v-select v-model="mock.practice_area_id"
                  :items="practice_areas"
                  item-text="name"
                  item-value="id"
                  label="Practice area"
                  required outlined
                  :error-messages="api_errors['practice_area_id']"
                  dense
        />

        <v-select v-model="mock.session_type_id"
                  :items="session_types"
                  item-text="name"
                  item-value="id"
                  label="Session type"
                  required outlined
                  :error-messages="api_errors['session_type_id']"
                  dense
        />

        <v-combobox v-model="mock.tutors"
                    :items="available_tutors"
                    item-text="nickname"
                    item-value="id"
                    label="Tutors"
                    hide-selected
                    multiple
                    required
                    outlined
                    :error-messages="api_errors['tutors']"
                    dense
                    deletable-chips small-chips
        >
          <template v-slot:item="{item}">
            <v-chip class="ma-2">{{ item.nickname }}</v-chip>
            {{ item.profile_type }} ({{ item.full_name }})
          </template>
        </v-combobox>
      </v-card-text>
      <v-toolbar dense flat outlined color="blur">Tutor instruction (used for calendars)</v-toolbar>
      <v-card-text>
        <vue-editor id="tutors-instruction-editor"
                    v-model="mock.tutor_instruction"
                    :editor-toolbar="toolbar"
        />

      </v-card-text>
      <v-toolbar dense flat outlined color="blur">Candidate instruction (used for calendars)</v-toolbar>
      <v-card-text>
        <vue-editor id="candidate-instruction-editor"
                    v-model="mock.candidate_instruction"
                    :editor-toolbar="toolbar"
        />
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn color="error" @click="destroy_dialog = !destroy_dialog">Delete mock</v-btn>
        <v-spacer/>
        <v-btn @click="$emit('loadMock')">Cancel</v-btn>
        <v-btn @click="updateMock">Apply</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="destroy_dialog" max-width="510px">
      <v-card dark flat color="error">
        <v-card-actions class="justify-center">
          <v-icon dark large>mdi-alert</v-icon>
        </v-card-actions>
        <v-divider/>
        <v-card-text class="text-center">
          <p class="ma-0">Attention! All children will be removed along with the mock.</p>
          <p class="ma-0">Access to data from sessions will be canceled.</p>
          <p class="ma-0">We hope you know what you are doing</p>
        </v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="destroy_dialog =!destroy_dialog">Cancel</v-btn>
          <v-btn @click="deleteMock">Yes, delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    mocks: {
      type: Array,
      default: Array
    },
    mock: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    tutors: [],
    api_errors: [],
    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["image", "link", "formula"],
    ],
    destroy_dialog: false
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
    available_parents: function () {
      let mocks = []
      mocks.push(...this.mocks)
      if (this.mock){
        mocks = mocks.filter(item => item.id !== this.mock.id)
            .filter(item => item.practice_area_id === this.mock.practice_area_id)
            .filter(item => item.parent_id === null)
            // .filter(item => {
            //   if(item.children && item.children.id === this.mock.id) return true
            //   return item.children === null
            // })
      }
      return mocks
    },
    available_tutors: function () {
      if(!this.mock) return []
      return this.tutors.filter(item => {
        let has_practice_area = item.practice_areas.find(pa => pa.id === this.mock.practice_area_id)
        let has_session_type = item.session_types.find(st => st.id === this.mock.session_type_id)
        if(has_practice_area && has_session_type) return item
      })
    },
  },
  created() {
    this.loadTutors()
  },
  methods: {
    async loadTutors() {
      this.tutors = await this.axios.get(`api/tutors`).then(({data}) => data.data)
    },
    updateMock() {
      this.api_errors = []
      this.app_loading = true
      this.axios.put(`api/mocks/${this.$route.params.mock_id}`, {
        ...this.mock,
        tutors: this.mock.tutors.map(item => item.id),
      })
          .then(() => {
            this.$emit('loadMock')
            this.$notify('Success!', 'success')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    },
    deleteMock() {
      this.axios.delete(`api/mocks/${this.$route.params.mock_id}`)
          .then(() => {this.$router.push({name: 'Mocks'})})
    }
  }
}
</script>